import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Spinner(props) {
	return <FontAwesomeIcon icon="spinner" spin {...props}/>;
}
